module.exports = __webpack_public_path__ + "img/tweet-icon.cce287d.svg";